import Icon from "@mdi/react";
import { mdiClose, mdiChevronDown } from "@mdi/js";
import useComponentVisible from "utils/useComponentVisible";
import { getOptionsByConfig } from "utils/products";
import "./SelectConfig.scss";
import { formatLabelSpecs } from "utils/general";
import TooltipInfo from "components/tooltip-info/TooltipInfo";

const SelectConfig = (props) => {
  const { ref, isComponentVisible, setIsComponentVisible, toggling } =
    useComponentVisible(false);

  const handleChange = (option) => {
    props.setActiveConfig(props.target, option, option.reference);
    setIsComponentVisible(false);
  };

  const handleReset = (event) => {
    event.stopPropagation();
    if (!!props.tempConfig?.setting) {
      const option = props.tempConfig?.setting[props.target];
      props.resetActiveConfig(props.target, option?.reference);
    }
  };

  const hasValue = props.value && props.value !== `undefined"`;
  const displayLabel = formatLabelSpecs(props.target);

  return (
    <div
      ref={ref}
      className={`configuration__select-config ${
        isComponentVisible ? "active" : ""
      }`}
    >
      <div className="select-line">
        <div className="label-with-info">
          <span className="label">{displayLabel}</span>
          <TooltipInfo
            text={renderInfoSpec(props.target)}
            ariaLabel={`Info ${formatLabelSpecs(props.target)}`}
            placement="right"
          />
        </div>

        <div className="select-control" onClick={toggling}>
          <span className={`value ${!hasValue ? "placeholder" : ""}`}>
            {hasValue ? props.value : "Select"}
          </span>

          {hasValue && !props.isAlreadySetted ? (
            <Icon
              path={mdiClose}
              size={1}
              style={{ width: 24, height: 24 }}
              onClick={(event) => handleReset(event)}
            />
          ) : (
            <Icon
              path={mdiChevronDown}
              size={1}
              style={{ width: 24, height: 24 }}
              className={isComponentVisible ? "active" : ""}
            />
          )}
        </div>
      </div>

      {isComponentVisible && (
        <div className="options-container">
          {getOptionsByConfig(
            props.target,
            props.tempConfig.setting,
            props.type
          ).map((option, i) => {
            return (
              <div
                key={`option_${i}`}
                onClick={() => handleChange(option)}
                className="option"
              >
                {props.target === "port" ? `${option.value}"` : option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SelectConfig;

const renderInfoSpec = (spec) => {
  switch (spec) {
    case "body_size":
      return "Nominal diameter of coupling body";
    case "litre":
      return "Typical rated flow relative to the size, in accordance with ISO norm standard";
    case "port":
      return "Size of the port";
    case "thread":
      return "Port type to connect with fitting";
    default:
  }
};
